/* global Drupal */
import announce from '../../00-base/global/utils/announce'

let cameraState = '';
let CTReady = false;
let CameraTag = window.CameraTag;
let activeVideoType = null;
const cameraEl = document.querySelector('#videoCapture');
const cameraId = 'videoCapture';

/**
 * Attach handler for state changes inside cameraTag
 * @param {Object} CameraTag - The cameraTag object
 */
function bindCameraTagStates(CameraTag) {

  // When waiting for hardware
  CameraTag
    .observe(cameraId, 'waitingForCameraActivity',
      () => setCameraState('waitingForCameraActivity'));

  // Error with hardware
  CameraTag
    .observe(cameraId, 'hardwareError',
      () => setCameraState('hardwareError'));

  CameraTag
    .observe(cameraId, 'cameraDenied',
    () => setCameraState('hardwareError'));

  // 5s countdown before recording
  CameraTag
    .observe(cameraId, 'countdownStarted',
      () => setCameraState('countingIn'));

  // Recording started
  CameraTag
    .observe(cameraId, 'recordingStarted',
      () => setCameraState('recording'));

  // Recording paused
  CameraTag
    .observe(cameraId, 'recordingPaused',
      () => setCameraState('recordingPaused'));

  // When moving from paused to recording
  CameraTag
    .observe(cameraId, 'recordingResumed',
      () => setCameraState('recording'));

  // When the time limit is up OR the recording is manually stopped
  CameraTag
    .observe(cameraId, 'recordingStopped', () => {
    // const nextFocus = document.querySelector('#lst-post-record');
    // if (nextFocus) {
    //   nextFocus.focus();
    // }
    if (camera.getState() === 'readyToPublish') {
      setCameraState('readyToPublish');
    } else {
      setCameraState('recordingStopped');
    }
  });

  // When reviewing a recording starts
  CameraTag
    .observe(cameraId, 'playbackStarted',
      () => setCameraState('playback'));

  // Recording playback ends OR is manually stopped
  CameraTag
    .observe(cameraId, 'playbackStopped',
      () => setCameraState('readyToPublish'));

  // A recording is available to upload
  CameraTag
    .observe(cameraId, 'readyToPublish',
      () => setCameraState('readyToPublish'));

  // Upload Started (also see 'uploadAborted'?)
  // N.B. I think this is for literal file uploads
  CameraTag
    .observe(cameraId, 'uploadStarted',
      () => setCameraState('uploadStarted'));

  // When upload begins?
  CameraTag
    .observe(cameraId, 'publishing',
      () => setCameraState('publishing'));

  // When finished uploading
  CameraTag
    .observe(cameraId, 'published',
      () => setCameraState('published'));

  // When thumbnail is ready?
  CameraTag
    .observe(cameraId, 'processed',
      () => setCameraState('processed'));

  CameraTag
    .observe(cameraId, 'serverConnected',
      () => setCameraState('serverConnected'));

}

/**
 * Set function for the current state of cameraTag
 * @param {string} newState -  The reference to the new cameraTag state
 */
function setCameraState(newState) {
  // Run updates before changing the state
  cameraTagUpdateHooks(newState);
  cameraState = newState;
}

// Stop video playback or recording
/**
 * @param {Object} e - The event object
*/
function stopVideoHandler(e) {
  const camera = CameraTag.cameras[cameraId];
  if (
    e.keyCode === 27 || // Esc
    e.keyCode === 13 || // Enter
    e.keyCode === 32    // Space
  ) {
    if (activeVideoType === 'recording') {
      camera.stopRecording();
    }
    else if (activeVideoType === 'playback') {
      camera.stopPlayback();
    }
  }
  // Reset flag for video playback type
  activeVideoType = null;
}

/**
 * Run update based on current / new state
 * @param {string} newState - The reference to the new cameraTag state
 */
function cameraTagUpdateHooks(newState) {

  // Used for accessing aria-live translations
  const ariaKey = `sys.cameratag.custom.arialive.${newState}`;

  // When CameraTag first bootstraps
  // OR when moving from settings
  // n.b. might make more sense to refactor as two states
  if (newState === 'initialized') {

    // Focus the first button in either case
    document
      .querySelector(`#videoCapture-start-screen button.cameratag_settings_btn`)
      .focus();

    // Init code for bootstrapping
    if (cameraState !== 'settings') {
      // Stop parent form submission on button clicks
      document.querySelectorAll('.camera_tag button').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
        });
      });

      bindCameraTagStates(CameraTag);

      // Setting up the MO here, as it only needs to be bound initially
      bindSettingsObserver();
    }
  }

  // Auto focus when entering settings
  if (newState === 'settings') {
    document.querySelector('#webcam-select').focus();
  }

  // If coming from settings focus on settings
  if (cameraState === 'settings') {
    document.querySelector(`#videoCapture-start-screen button.cameratag_settings_btn`).focus();
  }

  // When recording or reviewing
  // Handle the two states that have different methods for stopping
  if (newState === 'recording' ||
      newState === 'playback'
    ) {

    // Focus on stop button
    document
      .querySelector(`#videoCapture-${newState}-screen button.cameratag_stop`)
      .focus();

    // Keyboard stop events
    document.addEventListener('keydown', (e) => stopVideoHandler(e));

    // Set type
    activeVideoType = newState;
  }
  else {
    // Unbind event handler
    document.removeEventListener('keydown', stopVideoHandler);
  }

  // On Accept / review / re-record
  if (newState === 'readyToPublish') {
   
    setTimeout(() => {
        const nextFocus = document.querySelector('#lst-post-record button.cameratag_accept_btn');
        nextFocus.focus()
      }, 200);
  }

  // On Upload success screen
  if (newState === 'published') {
    const buttonDiv = document.querySelector('.form-submit');
    const button = buttonDiv.querySelector('input');

    // Show / Focus on submit button
    buttonDiv.style.display = 'inline-block';
    button.focus();
  }

  // Update the live messages if the state matches a key
  // Otherwise clear it
  if (window.drupalTranslations.strings[""][ariaKey]) {
    setTimeout(() =>
    {setLiveMessage({
      text: Drupal.t(ariaKey),
      type: 'assertive',
    });}, 50)
  }
  else {
    setLiveMessage({
      text: '',
      type: 'assertive',
    });
  }
}

// Observe when settings opened / closed
function bindSettingsObserver() {
  let settingsOpen = false;
  const settingsScreen = document
    .querySelector('#videoCapture-device-selection-screen');
  const webcamSelect = document
    .querySelector('#webcam-select');
  const micSelect = document
    .querySelector('#mic-select');

  const observer = new MutationObserver(() => {
    /**
     * The only sensible way to detect this state
     * is to see if the screen is shown
     */
    settingsOpen = (settingsScreen.style.display !== 'none');
    if (settingsOpen) {
      // Need to update the state manually
      setCameraState('settings');
    }
  });
  observer.observe(settingsScreen, {attributes: true});

  // Add listener for saving settings
  document
    .querySelector(`#${cameraId} .cameratag_save_device_selection`)
    .addEventListener('click', (e) => {
      // Because state was set manually, it needs to be reverted manually
      setCameraState('initialized');
    });

  /**
   *
   * Ensure no empties in drop downs
   * Sometimes labels for devices aren't defined - which isn't very useful
   * It seems sensible to assume system hardware will appear first (still an assumption)
   * Anything unlabelled afterwards is 'Unknown'
   * Annoyingly when permission is granted, the Select is modified
   */
  const fillOptions = (select) => {
    if (select.options.length) {
      if (
        select.options.length === 1 &&
        select.options[0].innerText === ''
      ) {
        select.options[0].innerText = 'Default'
      } else {
        for (const option of select.options) {
          if (option.innerText === '') {
            option.innerText = Drupal.t('sys.cameratag.custom.default');
          }
        }
      }
    }
    else {
      let emptyOption = document.createElement('option');
      emptyOption.innerText = Drupal.t('sys.cameratag.custom.default_unknown');
      select.appendChild(emptyOption);
    }
  };

  // Add Observers to check values of selects
  [
    webcamSelect,
    micSelect,
  ].forEach(select => {
    // Run initially then again if select is updated
    const observer = new MutationObserver(() => {
      fillOptions(select);
    });
    observer.observe(webcamSelect, {childList: true});
    fillOptions(select);
  });
}

/**
 * Overwrite the default cameraTag messages with Drupal values
 * Let me be clear that because of how Drupal.t() works
 * This cannot be a loop, or use any runtime values
 */
function setCameraTagStrings() {
  // The keys here map directly between the the CameraTag data object and Drupal.t
  window.CT_i18n[1] = Drupal.t('sys.cameratag.1');
  window.CT_i18n[2] = Drupal.t('sys.cameratag.2');
  window.CT_i18n[3] = Drupal.t('sys.cameratag.3');
  window.CT_i18n[8] = Drupal.t('sys.cameratag.8');
  window.CT_i18n[9] = Drupal.t('sys.cameratag.9');
  window.CT_i18n[10] = Drupal.t('sys.cameratag.10');
  window.CT_i18n[11] = Drupal.t('sys.cameratag.11');
  window.CT_i18n[12] = Drupal.t('sys.cameratag.12');
  window.CT_i18n[13] = Drupal.t('sys.cameratag.13');
  window.CT_i18n[14] = Drupal.t('sys.cameratag.14');
  window.CT_i18n[15] = Drupal.t('sys.cameratag.15');
  window.CT_i18n[16] = Drupal.t('sys.cameratag.16');
  window.CT_i18n[17] = Drupal.t('sys.cameratag.17');
  window.CT_i18n[20] = Drupal.t('sys.cameratag.20');
  window.CT_i18n[23] = Drupal.t('sys.cameratag.23');
  window.CT_i18n[28] = Drupal.t('sys.cameratag.28');
  window.CT_i18n[29] = Drupal.t('sys.cameratag.29');
  window.CT_i18n[30] = Drupal.t('sys.cameratag.30');
  window.CT_i18n[31] = Drupal.t('sys.cameratag.31');
  window.CT_i18n[32] = Drupal.t('sys.cameratag.32');
  window.CT_i18n[33] = Drupal.t('sys.cameratag.33');
  window.CT_i18n[34] = Drupal.t('sys.cameratag.34');
  window.CT_i18n[35] = Drupal.t('sys.cameratag.35');
  window.CT_i18n[36] = Drupal.t('sys.cameratag.36');
  window.CT_i18n[37] = Drupal.t('sys.cameratag.37');
  window.CT_i18n[38] = Drupal.t('sys.cameratag.38');
  window.CT_i18n[39] = Drupal.t('sys.cameratag.39');
  window.CT_i18n[40] = Drupal.t('sys.cameratag.40');
  window.CT_i18n[41] = Drupal.t('sys.cameratag.41');
  window.CT_i18n[42] = Drupal.t('sys.cameratag.42');
  window.CT_i18n[43] = Drupal.t('sys.cameratag.43');
  window.CT_i18n[44] = Drupal.t('sys.cameratag.44');
  window.CT_i18n[46] = Drupal.t('sys.cameratag.46');
  window.CT_i18n[47] = Drupal.t('sys.cameratag.47');
  window.CT_i18n[48] = Drupal.t('sys.cameratag.48');
  window.CT_i18n[98] = Drupal.t('sys.cameratag.98');
  window.CT_i18n[99] = Drupal.t('sys.cameratag.99');
  window.CT_i18n[100] = Drupal.t('sys.cameratag.100');
  /**
   * IMPORTANT: Please add newly added strings here
   * as well as the YAML if they need to be picked up in the JS
   */
  Drupal.t('sys.cameratag.custom.arialive.hardwareError');
  Drupal.t('sys.cameratag.custom.arialive.initialized');
  Drupal.t('sys.cameratag.custom.arialive.settings');
  Drupal.t('sys.cameratag.custom.arialive.countingIn');
  Drupal.t('sys.cameratag.custom.arialive.recording');
  Drupal.t('sys.cameratag.custom.arialive.readyToPublish');
  Drupal.t('sys.cameratag.custom.arialive.playback');
  Drupal.t('sys.cameratag.custom.arialive.publishing');
  Drupal.t('sys.cameratag.custom.arialive.published');
}

// Setup the aria-live announcers
// Two available, 'polite' and 'assertive'
// function initAriaLive() {
//   const assertive = document.createElement('div');
//   let polite;
//   assertive.setAttribute('id', 'aria-assertive-log');
//   assertive.className = 'visually-hidden';
//   assertive.setAttribute('aria-atomic', 'true');
//   assertive.setAttribute('aria-live', 'assertive');
//   assertive.setAttribute('aria-relevant', 'all');
//   assertive.setAttribute('role', 'log');

//   // Clone for 'polite'
//   polite = assertive.cloneNode();
//   assertive.setAttribute('id', 'aria-polite-log');
//   polite.setAttribute('aria-live', 'polite')

//   document.body.appendChild(assertive);
//   document.body.appendChild(polite);
// }

/**
 * Render live messages
 * @param {Object} msg - Message object
 * @param {string} msg.text - The text for the live message
 */
function setLiveMessage(msg) {
  announce(msg.text);
}

// Bootstrap our cameraTag
function initCameraTagForm() {

  if (!cameraEl) return;

  CameraTag.setup();
  setCameraTagStrings();
  // Attach one observer so other things can happen after init
  // E.g. DOM will be done with all replacement markup
  CameraTag
    .observe('videoCapture', 'initialized',
      () => setCameraState('initialized')
    );

}

export default initCameraTagForm;
